import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    alignItems: "flex-start",
    width: 605,
    maxWidth: 605,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
    },
  },
  tags: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    overflow: "hidden",
    transition: "max-height 0.1s ease",
  },
  expandButton: {
    color: theme.palette.primary.main,
  },
}));
